import { envType } from '../../../../common/types';
import { getEnvType } from '../../../../utils';

export const hostName =
	getEnvType() === envType.LOCAL ? process.env.REMOTE_DOMAIN || '' : window.location.hostname;

export const siteName = hostName.split('.')[0].replace('https://', '');

// Feature Gate Names
export const enableCodePlannerSiteSettingsFeatureGateName = 'code-planner-site-settings-enabled';
